import React, { useState, useEffect } from "react";
import Modal from "./modal"; // Assuming you have a reusable Modal component
import Modalbanner from "../../assets/images/gallery/2025/july/Status.jpg";
import Modalbanner2 from "../../assets/images/news&event/JSA COLLEGE-2.png";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/images/logo/JsaAgri-logo-1.png";
// import Rightmodal from  "../../assets/images/Modal image/Modal imag (2).jpeg";// For routing functionality
// import leftmodal from "../../assets/images/Modal image/Modal imag (1).jpeg";
import { FaLeaf, FaSeedling, FaFlask,FaUserGraduate  } from "react-icons/fa";

const HomeWithImageModal = () => {
  // State management for modals
  const [isFirstModalOpen, setFirstModalOpen] = useState(false);
  const [isSecondModalOpen, setSecondModalOpen] = useState(false);
  const [isThirdModalOpen, setThirdModalOpen] = useState(false);
  const [isFourthModalOpen, setFourthModalOpen] = useState(false);
  const [isSideModalsOpen, setSideModalsOpen] = useState(false); // New state for side modals

  const location = useLocation(); // Get the current route's pathname

  // Open the first modal if on the Home page
  useEffect(() => {
    if (location.pathname === "/") {
      setFirstModalOpen(true);
    }
  }, [location.pathname]);

  // Handlers for closing each modal and opening the next
  const handleFirstModalClose = () => {
    setFirstModalOpen(false);
    setSecondModalOpen(true); // Open second modal
  };

  const handleSecondModalClose = () => {
    setSecondModalOpen(false);
    setThirdModalOpen(true); // Open third modal
  };

  const handleThirdModalClose = () => {
    setThirdModalOpen(false);
    setSideModalsOpen(true); // Open left and right side modals
  };
  const handleFourthModalClose = () => {
    setFourthModalOpen(false);
    setSideModalsOpen(true); // Open left and right side modals
  };

  const handleSideModalsClose = () => {
    setSideModalsOpen(false); // Close side modals
  };

  return (
    <div className="modal-screen">
         {/* Second Modal */}
          {/* <Modal isOpen={isFirstModalOpen} onClose={handleFirstModalClose}>
             <h5>JSA COLLEGE OF AGRICULTURE AND TECHNOLOGY</h5>
               <h6>Admission Enquiry 2026-2027 </h6>
                <h6></h6>
        <Link
          to=" https://docs.google.com/forms/d/e/1FAIpQLSeZxcJeVBJrzsBiwXSC3POLhWl46Zx3gotAEiTtkEriulH8tA/viewform"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button type="button" className="btn btn-success">
             Admission Enquiry Click Here
          </button>
        </Link>
            
      </Modal> */}
<Modal isOpen={isFirstModalOpen} onClose={handleFirstModalClose}>
  <div className="container p-3 modal-bg">

    {/* Header */}
    <div className="text-center mb-4">
      <h5 className="fw-bold text-white">
        JSA COLLEGE OF AGRICULTURE AND TECHNOLOGY
      </h5>
      <h6 className="text-light">Admission Open 2026-2027</h6>
    </div>

    <div className="row">

 <div className="col-md-6 mb-3 animate-row ug-row">
  <div className="card custom-card h-100">
    <div className="card-body">
      <h5 className="fw-bold title mb-3">
        <FaUserGraduate className="me-2 icon-animate" />
        UG Courses
      </h5>
      <ul className="list-unstyled">
        <li><FaSeedling className="me-2 icon-animate" />B.Sc. (Hons) Agriculture</li>
        <li><FaSeedling className="me-2 icon-animate" />B.Sc. (Hons) Horticulture</li>
      </ul>
    </div>
  </div>
</div>

<div className="col-md-6 mb-3 animate-row pg-row">
  <div className="card custom-card h-100">
    <div className="card-body">
      <h5 className="fw-bold title mb-3">
        <FaUserGraduate className="me-2 icon-animate" />
        PG Courses
      </h5>
      <ul className="list-unstyled">
        <li><FaSeedling className="me-2" />M.Sc. (Agri) in Agronomy</li>
        <li><FaSeedling className="me-2" />M.Sc. (Agri) in Genetics & Plant Breeding</li>
        <li><FaSeedling className="me-2" />M.Sc. (Agri) in Soil Science & Agricultural Chemistry</li>
      </ul>
    </div>
  </div>
</div>

    </div>

    {/* Button */}
    <div className="text-center mt-3">
      <Link
        to="https://docs.google.com/forms/d/e/1FAIpQLScg53rgQGbNWFk9wlG4YWp--WVzKusWHYuqMNRvEkV9OTc8Tg/viewform?usp=dialog"
        rel="noopener noreferrer"
      >
        <button type="button" className="btn btn-success glow-btn px-4">
          Admission Enquiry Click Here
        </button>
      </Link>
    </div>

  </div>
</Modal>

      {/* // Second Modal */}
   {/* <Modal isOpen={isSecondModalOpen} onClose={handleSecondModalClose}>
      <h5>LATEST EVENT</h5>
        <img
          src={Modalbanner2}
          alt="Second Modal Banner"
          style={{ width: "100%", height: "350px" }}
        />         
         <h6>Radiance2k25 2025</h6>
         <h6>  18 July 2025</h6>
      </Modal> */}
      
      {/* <Modal isOpen={isFourthModalOpen} onClose={handleFourthModalClose}>
        <img
          src={Modalbanner2}
          alt="Fourth Modal Banner"
          style={{ width: "100%", height: "auto" }}
        />
        <h5></h5>
      </Modal> */}
    </div>
  );
};

export default HomeWithImageModal;
